import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export function ReviewIoWidget({ id = 'badge-ribbon', sx }) {
  const reviewWidget = useRef(null);

  useEffect(() => {
    const isReviewIoWidgetScriptAvailable = window && window.reviewsBadgeRibbon;

    if (
      !isReviewIoWidgetScriptAvailable ||
      isReviewWidgetAlreadyInDom(reviewWidget)
    ) {
      return;
    }

    loadReviewWidget(id);
  });

  useTrackReviewWidgetClicks();

  return (
    <Box
      id={id}
      ref={reviewWidget}
      sx={sx}
    />
  );
}

function useTrackReviewWidgetClicks() {
  useEffect(() => {
    window.focus();

    const listener = window.addEventListener('blur', () => {}, { once: true });

    return () => window.removeEventListener('blur', listener);
  }, []);
}

function loadReviewWidget(id) {
  window.reviewsBadgeRibbon(id, {
    store: 'www.venuescanner.com',
    size: 'small',
    mono: true,
  });
}

const isReviewWidgetAlreadyInDom = reviewWidget =>
  reviewWidget.current?.childElementCount;
